module.exports = __webpack_public_path__ + "assets/img/film-bj.72f15ab9.png";